import { styled, Typography } from "@mui/material";

export const PanelItemName = styled(Typography)`
  color: inherit;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
`;
